import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowUp,
  CheckCircle2,
  Truck,
  ShieldCheck,
  Clock,
  ArrowRight,
} from "lucide-react";

const WHATSAPP_NUMBER = "916235523889";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (email.trim()) {
      setSubscribed(true);
      setEmail("");
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const enquireWhatsApp = () => {
    const message =
      "Hi VEDHYAS, I would like to know more about your saree collections.";

    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      message
    )}`;

    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <footer className="relative mt-28 overflow-hidden border-t border-[#4A0E17] bg-[#20050A] pt-20 pb-12 text-[#FDFBF7]">

      {/* Ambient background */}
      <div className="pointer-events-none absolute left-1/4 top-0 h-96 w-96 rounded-full bg-[#4A0E17]/30 blur-3xl" />

      <div className="pointer-events-none absolute bottom-0 right-10 h-80 w-80 rounded-full bg-[#E8DFC8]/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

        {/* =========================================
            TRUST BAR
        ========================================= */}

        <div className="grid grid-cols-1 gap-4 border-b border-[#E8DFC8]/20 pb-14 text-center sm:grid-cols-3 sm:text-left">

          {/* Delivery */}
          <div className="flex items-center justify-center space-x-4 rounded-2xl border border-[#E8DFC8]/15 bg-[#4A0E17]/20 p-4 backdrop-blur-sm sm:justify-start">

            <div className="rounded-xl border border-[#E8DFC8]/30 bg-[#4A0E17] p-3 text-[#E8DFC8]">
              <Truck className="h-5 w-5" />
            </div>

            <div>
              <h5 className="font-serif text-xs font-bold uppercase tracking-wider text-[#FDFBF7]">
                Pan-India Delivery
              </h5>

              <p className="mt-0.5 text-[11px] text-[#E8DFC8]/80">
                Carefully packed sarees delivered across India
              </p>
            </div>

          </div>


          {/* Authenticity */}
          <div className="flex items-center justify-center space-x-4 rounded-2xl border border-[#E8DFC8]/15 bg-[#4A0E17]/20 p-4 backdrop-blur-sm sm:justify-start">

            <div className="rounded-xl border border-[#E8DFC8]/30 bg-[#4A0E17] p-3 text-[#E8DFC8]">
              <ShieldCheck className="h-5 w-5" />
            </div>

            <div>
              <h5 className="font-serif text-xs font-bold uppercase tracking-wider text-[#FDFBF7]">
                Thoughtfully Selected
              </h5>

              <p className="mt-0.5 text-[11px] text-[#E8DFC8]/80">
                Sarees chosen for quality, beauty and comfort
              </p>
            </div>

          </div>


          {/* Assistance */}
          <div className="flex items-center justify-center space-x-4 rounded-2xl border border-[#E8DFC8]/15 bg-[#4A0E17]/20 p-4 backdrop-blur-sm sm:justify-start">

            <div className="rounded-xl border border-[#E8DFC8]/30 bg-[#4A0E17] p-3 text-[#E8DFC8]">
              <Clock className="h-5 w-5" />
            </div>

            <div>
              <h5 className="font-serif text-xs font-bold uppercase tracking-wider text-[#FDFBF7]">
                Personal Assistance
              </h5>

              <p className="mt-0.5 text-[11px] text-[#E8DFC8]/80">
                Get help choosing the perfect saree
              </p>
            </div>

          </div>

        </div>


        {/* =========================================
            MAIN FOOTER
        ========================================= */}

        <div className="grid grid-cols-1 gap-12 border-b border-[#E8DFC8]/20 py-16 md:grid-cols-12">

          {/* BRAND */}
          <div className="space-y-6 md:col-span-4">

            <Link to="/" className="inline-block">
              <h3 className="font-serif text-3xl font-bold tracking-wider text-[#FDFBF7]">
                VEDHYAS<span className="text-[#E8DFC8]">.</span>
              </h3>
            </Link>

            <p className="max-w-sm font-light text-xs leading-relaxed text-[#E8DFC8]/80">
              Thoughtfully curated sarees that celebrate timeless
              Indian elegance, beautiful fabrics and graceful
              everyday style.
            </p>


            {/* Social */}
            <div className="flex items-center space-x-3 pt-2">

              {/* Instagram */}
              <a
                href="#instagram"
                aria-label="Instagram"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-[#E8DFC8]/30 bg-[#4A0E17]/40 text-[#E8DFC8] transition-all duration-300 hover:bg-[#E8DFC8] hover:text-[#20050A]"
              >
                <svg
                  className="h-4 w-4 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-.119-.112-.224-.083-.345.09-.375.293-1.199.334-1.363.053-.225.172-.271.401-.165 1.495.69 2.433 2.878 2.433 4.646 0 3.776-2.748 7.252-7.92 7.252-4.158 0-7.392-2.967-7.392-6.923 0-4.135 2.607-7.462 6.233-7.462 1.214 0 2.354.629 2.758 1.379l.749-2.848c.269-1.045 1.004-2.352 1.498-3.146C14.306 2.345 13.123 2.155 12 2.163z" />
                </svg>
              </a>

              {/* Facebook */}
              <a
                href="#facebook"
                aria-label="Facebook"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-[#E8DFC8]/30 bg-[#4A0E17]/40 text-[#E8DFC8] transition-all duration-300 hover:bg-[#E8DFC8] hover:text-[#20050A]"
              >
                <svg
                  className="h-4 w-4 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path d="M9 8H6v4h3v12h5V12h3.642L18 8h-4V6.333C14 5.374 14.5 5 15.5 5H18V0h-3.808C10.592 0 9 1.592 9 4.333V8z" />
                </svg>
              </a>

            </div>

          </div>


          {/* =========================================
              COLLECTIONS
          ========================================= */}

          <div className="md:col-span-2">

            <h4 className="mb-5 font-serif text-xs font-bold uppercase tracking-widest text-[#E8DFC8]">
              Collections
            </h4>

            <ul className="space-y-3 text-xs font-light text-[#E8DFC8]/80">

              <li>
                <Link
                  to="/catalog?cat=pure-silk"
                  className="inline-block transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Pure Silk
                </Link>
              </li>

              <li>
                <Link
                  to="/catalog?cat=tussar-silk"
                  className="inline-block transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Tussar Silk
                </Link>
              </li>

              <li>
                <Link
                  to="/catalog?cat=semi-tussar-silk"
                  className="inline-block transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Semi Tussar Silk
                </Link>
              </li>

              <li>
                <Link
                  to="/catalog?cat=fancy-sarees"
                  className="inline-block transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Fancy Sarees
                </Link>
              </li>

              <li>
                <Link
                  to="/catalog?cat=pure-cotton"
                  className="inline-block transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Pure Cotton
                </Link>
              </li>

              <li>
                <Link
                  to="/catalog?cat=art-silk"
                  className="inline-block transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Art Silk
                </Link>
              </li>

            </ul>

          </div>


          {/* =========================================
              CUSTOMER CARE
          ========================================= */}

          <div className="md:col-span-2">

            <h4 className="mb-5 font-serif text-xs font-bold uppercase tracking-widest text-[#E8DFC8]">
              Customer Care
            </h4>

            <ul className="space-y-3 text-xs font-light text-[#E8DFC8]/80">

              <li>
                <Link
                  to="/heritage"
                  className="inline-block transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Our Story
                </Link>
              </li>

              <li>
                <a
                  href="#shipping"
                  className="inline-block transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Shipping
                </a>
              </li>

              <li>
                <a
                  href="#care"
                  className="inline-block transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Saree Care
                </a>
              </li>

              <li>
                <a
                  href="#styling"
                  className="inline-block transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Styling Assistance
                </a>
              </li>

              <li>
                <button
                  type="button"
                  onClick={enquireWhatsApp}
                  className="transition-all duration-200 hover:translate-x-1 hover:text-[#FDFBF7]"
                >
                  Enquire on WhatsApp
                </button>
              </li>

            </ul>

          </div>


          {/* =========================================
              JOURNAL / NEWSLETTER
          ========================================= */}

          <div className="space-y-4 rounded-2xl border border-[#E8DFC8]/15 bg-[#4A0E17]/20 p-6 backdrop-blur-sm md:col-span-4">

            <h4 className="font-serif text-xs font-bold uppercase tracking-widest text-[#E8DFC8]">
              The VEDHYAS Journal
            </h4>

            <p className="text-xs font-light leading-relaxed text-[#E8DFC8]/80">
              Receive new saree arrivals, styling inspiration,
              collection stories and special VEDHYAS updates.
            </p>


            {subscribed ? (

              <div className="flex items-center space-x-2 rounded-xl border border-emerald-700/50 bg-emerald-950/60 p-3 text-xs text-emerald-300">

                <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-400" />

                <span>
                  You're now part of the VEDHYAS Journal.
                </span>

              </div>

            ) : (

              <form
                onSubmit={handleSubscribe}
                className="space-y-3"
              >

                <div className="relative flex items-center">

                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className="
                      w-full
                      rounded-xl
                      border
                      border-[#E8DFC8]/30
                      bg-[#20050A]/80
                      px-4
                      py-3.5
                      pr-12
                      text-xs
                      text-[#FDFBF7]
                      outline-none
                      placeholder:text-[#E8DFC8]/40
                      transition-all
                      duration-300
                      focus:border-[#E8DFC8]
                      focus:bg-[#20050A]
                    "
                  />

                  <button
                    type="submit"
                    title="Subscribe"
                    className="
                      absolute
                      right-1.5
                      rounded-lg
                      border
                      border-[#E8DFC8]/40
                      bg-[#4A0E17]
                      p-2
                      text-[#E8DFC8]
                      transition-all
                      duration-300
                      hover:bg-[#6B1320]
                    "
                  >
                    <ArrowRight className="h-4 w-4" />
                  </button>

                </div>

                <p className="text-[10px] text-[#E8DFC8]/60">
                  Stay connected with VEDHYAS. Unsubscribe anytime.
                </p>

              </form>

            )}

          </div>

        </div>


        {/* =========================================
            BOTTOM
        ========================================= */}

        <div className="flex flex-col items-center justify-between space-y-4 pt-8 text-[11px] text-[#E8DFC8]/70 sm:flex-row sm:space-y-0">

          <p>
            © {new Date().getFullYear()} VEDHYAS. All Rights Reserved.
          </p>

          <div className="flex items-center space-x-5">

            <a
              href="#privacy"
              className="transition hover:text-[#FDFBF7]"
            >
              Privacy Policy
            </a>

            <span>•</span>

            <a
              href="#terms"
              className="transition hover:text-[#FDFBF7]"
            >
              Terms of Service
            </a>

            <span>•</span>

            <button
              onClick={scrollToTop}
              className="group flex items-center space-x-1.5 text-[#FDFBF7] transition hover:text-[#E8DFC8]"
            >
              <span>Back to top</span>

              <ArrowUp className="h-3.5 w-3.5 transition-transform duration-200 group-hover:-translate-y-0.5" />
            </button>

          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;